// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3FRkg","disabled":"FileBtn_disabled__1_zMC","warn":"FileBtn_warn__30JBq","fade":"FileBtn_fade__1WFOG"};